import { IApplicationState } from '../../types/redux';

export const selectMyHomeIdMigration = (state: IApplicationState) => state.myHomeMigrationBanner.myHomeIdMigration;
